import React, { createContext, useContext, useMemo } from 'react';
import { useWindowDimensions } from 'react-native';
import { BREAKPOINTS, CONTENT_MAX_WIDTH, SCALE_FACTORS, getBreakpoint } from './responsive';

const BreakpointContext = createContext(null);

export function BreakpointProvider({ children }) {
  const { width, height } = useWindowDimensions();

  const value = useMemo(() => {
    const breakpoint = getBreakpoint(width);
    return {
      breakpoint,
      contentMaxWidth: CONTENT_MAX_WIDTH[breakpoint],
      scaleFactor: SCALE_FACTORS[breakpoint],
      windowWidth: width,
      windowHeight: height,
      isTablet: breakpoint !== 'compact',
    };
  }, [width, height]);

  return (
    <BreakpointContext.Provider value={value}>
      {children}
    </BreakpointContext.Provider>
  );
}

export function useBreakpoint() {
  const context = useContext(BreakpointContext);
  if (!context) {
    throw new Error('useBreakpoint must be used within a BreakpointProvider');
  }
  return context;
}

export default useBreakpoint;
